export type PendoEnvironmentTypes =
  | 'US-PROD'
  | 'US-UAT'
  | 'US-DEMO'
  | 'US-TRAINING'
  | 'US-AUTO'
  | 'US-QA'
  | 'US-STAGING'
  | 'US-PERF2'
  | 'DEV-INT'
  | 'DEV'
  | 'UNKNOWN';

export enum PendoEventType {
  SIGNUP = 'program_user-onboarded',
  CHAT_MESSAGE_SENT = 'program_user-sent-in-app-message',
  CHECKLIST_TASK_COMPLETED = 'program_user-completed-checklist-task',
  READ_INSTRUCTION = 'program_user-read-instruction',
  ALL_ARTICLES = 'program_user-view-all-articles',
  SPECIFIC_ARTICLE = 'program_user-tapped-article',
  FAVORITE_ARTICLE = 'program_user-tapped-favorite-article',
  REMOVED_FAVORITE_ARTICLE = 'program_user-removed-favorite-article',
  SEARCH_KEYWORD_ARTICLE = 'program_user-searched-article-keyword',
  ALL_CARE_PROGRAMS = 'program_user-view-all-care-programs',
  SPECIFIC_HEALTH_TOPIC = 'program_user-tapped-health-topic',
  SPECIFIC_CARE_PROGRAM = 'program_user-tapped-care-program',
  REQUEST_TO_ENROLL = 'program_user-request-to-enroll',
  CHAT_WITH_YOUR_CARE_TEAM = 'program_user-tapped-chat-with-your-care-team',
}

interface PendoEventPayload {
  'Device Model'?: 'Browser';
}

export interface AllArticlesEvent extends PendoEventPayload {
  eventType: PendoEventType.ALL_ARTICLES;
}

export interface SpecificArticleEvent extends PendoEventPayload {
  eventType: PendoEventType.SPECIFIC_ARTICLE;
  articleId: string;
}

export interface FavoriteArticleEvent extends PendoEventPayload {
  eventType: PendoEventType.FAVORITE_ARTICLE;
  articleId: string;
}

export interface RemovedFavoriteArticleEvent extends PendoEventPayload {
  eventType: PendoEventType.REMOVED_FAVORITE_ARTICLE;
  articleId: string;
}

export interface SearchKeywordArticleEvent extends PendoEventPayload {
  eventType: PendoEventType.SEARCH_KEYWORD_ARTICLE;
  searchKeyword: string;
}
export interface AllCareProgramsEvent extends PendoEventPayload {
  eventType: PendoEventType.ALL_CARE_PROGRAMS;
}

export interface HealthTopicEvent extends PendoEventPayload {
  eventType: PendoEventType.SPECIFIC_HEALTH_TOPIC;
  topicId: string;
}

export interface CareProgramEvent extends PendoEventPayload {
  eventType: PendoEventType.SPECIFIC_CARE_PROGRAM;
  programId: string;
}

export interface RequestToEnrollEvent extends PendoEventPayload {
  eventType: PendoEventType.REQUEST_TO_ENROLL;
  programId: string;
}

export interface ChatWithYourCareTeamEvent extends PendoEventPayload {
  eventType: PendoEventType.CHAT_WITH_YOUR_CARE_TEAM;
}

export interface SighnupEvent extends PendoEventPayload {
  eventType: PendoEventType.SIGNUP;
}

export interface ChatMessageSentEvent extends PendoEventPayload {
  eventType: PendoEventType.CHAT_MESSAGE_SENT;
  messageId: string;
}

export interface CheckListTaskCompletedEventPayload extends PendoEventPayload {
  eventType: PendoEventType.CHECKLIST_TASK_COMPLETED;
  taskId: string;
}

export interface ReadInstructionEventPayload extends PendoEventPayload {
  eventType: PendoEventType.READ_INSTRUCTION;
  instructionId: string;
}

export type PendoTrackEventPayload =
  | AllArticlesEvent
  | SpecificArticleEvent
  | FavoriteArticleEvent
  | RemovedFavoriteArticleEvent
  | SearchKeywordArticleEvent
  | AllCareProgramsEvent
  | HealthTopicEvent
  | CareProgramEvent
  | RequestToEnrollEvent
  | ChatWithYourCareTeamEvent
  | SighnupEvent
  | ChatMessageSentEvent
  | CheckListTaskCompletedEventPayload
  | ReadInstructionEventPayload;

export interface PendoInitOptions {
  userId?: number;
  hospitalId?: number;
}
